<div id="{{ instanceIdent }}" *ngIf="iframeSrc as src">
  <iframe [src]="src"></iframe>
</div>
